<template>
  <div id="timeTravel" v-if="1==1">
    <!-- <div v-for="type in getKeys(this.$store.state)" :class="['data-el', toDisplayType(type, true)]" :key="type">
      <div class="data-type">{{ toDisplayType(type) }}</div>
      <div class="data-fields">
        <template v-if="Array.isArray(state[type])">
          <data-field
            v-for="field in state[type]"
            :key="field.key"
            :field="field"
            :depth="0">
          </data-field>
        </template>
        <template v-else>
          <data-field
            v-for="(value, key) in state[type]"
            :key="key"
            :field="{ value, key }"
            :depth="0">
          </data-field>
        </template>
      </div>
    </div> -->
    <button @click="undo">Undo</button>
  </div>
</template>

<script>
// https://stackoverflow.com/a/41375717
// Need to take state snapshots of the data I care about
// Build a middleware plugin for vuex to manage history

const keyOrder = {
  undefined: 1,
  props: 2,
  computed: 3,
  state: 1,
  getters: 2
}

export default {
  /* eslint-disable no-new */
  name: 'time-travel',

  mounted () {
    this.startState = window._.cloneDeep(this.$store.state)
    this.$store.subscribe(this.stateChange)
  },

  data () {
    return {
      startState: {},
      stateHistory: [],

      watchedMutations: [
        'setTabOrder',
        'setFieldType',
        'setFieldDisplayType',
        'setDocumentPageFields'
      ]
    }
  },

  methods: {
    stateChange (mutation) {
      if (mutation.type === 'setState') return
      if (mutation.type === 'setLastSaved') this.$bus.emit('saveAll')
      else this.stateHistory.push({mutation: mutation.type, state: window._.cloneDeep(this.$store.state)})
    },

    undo () {
      console.log('Undo')
      let lastState = this.stateHistory[this.stateHistory.length - 1]
      console.log(lastState.mutation)

      this.stateHistory.pop()
      this.$store.commit('setState', this.stateHistory[this.stateHistory.length - 1].state)
      this.$bus.emit('historyChange')
      // new window.Toast({message: 'Undid state ' + lastState.mutation})
    },

    redo () {
      this.$bus.emit('historyChange')
    },

    getKeys (state) {
      return Object.keys(state).sort((a, b) => {
        return (
          (keyOrder[a] || (a.charCodeAt(0) + 999)) -
          (keyOrder[b] || (b.charCodeAt(0) + 999))
        )
      })
    },

    toDisplayType (type, asClass) {
      return type === 'undefined'
        ? 'data'
        : asClass
          ? type.replace(/\s/g, '-')
          : type
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/editor/TimeTravel.vue